
import {defineComponent} from 'vue';
import {TAGS, TAG_P, TYPES} from './types';
import type {Tags, TextTypes} from './types';

export default defineComponent({
  name: 'OxdText',

  props: {
    tag: {
      type: String,
      required: false,
      default: TAG_P,
      validator: function (value: Tags) {
        return TAGS.indexOf(value) !== -1;
      },
    },
    type: {
      type: String,
      required: false,
      default: null,
      validator: function (value?: TextTypes) {
        if (value === undefined || value === null) {
          return true;
        }
        return TYPES.indexOf(value) !== -1;
      },
    },
  },

  computed: {
    classes(): object {
      return {
        'oxd-text': true,
        [`oxd-text--${this.tag}`]: true,
        [`oxd-text--${this.type}`]: !!this.type,
      };
    },
  },
});
